import React, { useState, useRef, useEffect } from 'react';
import styles from './CreateSpeech.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import userIcon from '../../../../assets/Imagess/userinputicon.svg';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import { useMutation } from 'react-query';
import axios from 'axios';
import {
  API_URL,
  quillFormats,
  quillModules,
  securityHeaders,
} from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { isEmpty, values } from 'lodash';
import '../../../../styles/Quill.css';
import { useFetchTestimonialById } from '../../../../Hooks/Testimonials';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import TextInput from '../../../Atoms/Inputs/TextInput';
import DatePicker from 'react-datepicker';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../../Molecules/Loader/Loader';

import he from 'he';
import UploadImage from '../../../Atoms/upload-image/UploadImage';
import TextEditor from '../../../Molecules/Email/TextEditor';
import DateInput from '../../../Atoms/Inputs/DateInput';
const validationSchema = Yup.object().shape({
  nameAr: Yup.string().required('Arabic name is required'),
  textAr: Yup.string().required('مطلوب تعبئته'),
  messageAr: Yup.string().required('Arabic message is required'),
  keyLocation: Yup.string().required('Key Location is required'),
  testimonialDate: Yup.string().required(
    'testimonialDate Location is required'
  ),
});
const pageOptions = [
  { value: 'HomePage', text: 'الصفحة الرئيسية', speech: '0', testimonial: '1' },

  {
    value: 'AboutTheAcadamy',
    text: 'عن الأكاديمية',
    speech: '1',
    testimonial: '0',
  },
  {
    value: 'AcademicsColledgeOfPostGraduate',
    text: 'كلية الدراسات العليا الأكاديمية',
    speech: '1',
    testimonial: '1',
  },
  {
    value: 'AcademicsCollegeOfLaw',
    text: 'كلية الحقوق الأكاديمية',
    speech: '1',
    testimonial: '1',
  },
  {
    value: 'Programs',
    text: 'البرامج',
    speech: '0',
    testimonial: '1',
  },
];
const UpdateSpeech = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { type, id } = params;
  const [imageSrc, setImageSrc] = useState('');
  const { data, isLoading, refetch } = useFetchTestimonialById(id);
  const formikRef = useRef(null);
  const customizedToast = useToast();

  useEffect(() => {
    if (!isEmpty(id) && undefined !== id) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(data)) {
      const testimonialData = data.data[0];
      formikRef.current.setValues({
        nameAr: testimonialData?.fullName_AR || '',
        testimonialDate: testimonialData?.testimonialDate
          ? new Date(testimonialData?.testimonialDate)
          : '',
        textAr: he.decode(testimonialData?.testimonial_AR || ''),
        messageAr: testimonialData?.messageAR || '',
        keyLocation: testimonialData?.keyLocation || '',
      });
      setImageSrc(
        `${testimonialData?.url}${testimonialData?.testimonialImage}`
      );
    }
  }, [data]);

  const createSpeech = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Testimonial/Testimonials`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      customizedToast.open(
        id
          ? type === 'speech'
            ? 'تم تحديث الخطاب بنجاح'
            : 'تم تحديث الشهادة بنجاح'
          : type === 'speech'
          ? 'تم إنشاء الخطاب بنجاح'
          : 'تم إنشاء الشهادة بنجاح'
      );

      setTimeout(() => {
        formikRef.current.resetForm();
        navigate('/home/testimonials', {
          state: { selected: type === 'speech' ? 'speech' : 'testimonials' },
        });
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('FullName_AR', values.nameAr);
    formData.append('Testimonial_AR', values.textAr);
    formData.append('MessageAR', values.messageAr);
    formData.append('IsTestimonial', 'speech' === type ? false : true);
    formData.append('KeyLocation', values.keyLocation);
    const testimonialId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('TestimonialId', testimonialId);
    if (undefined !== values.image) {
      formData.append('TestimonialImage', values.image);
    }
    values.testimonialDate &&
      formData.append(
        'TestimonialDate',
        moment(values.testimonialDate).format('YYYY-MM-DD')
      );
    createSpeech.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={
            !isEmpty(id)
              ? type === 'speech'
                ? 'تحديث الخطاب'
                : 'تحديث الشهادة'
              : type === 'speech'
              ? 'إنشاء خطاب جديد'
              : 'إنشاء شهادة جديدة'
          }
        />
      </div>
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: data?.data[0]?.fullName_AR || '',
            testimonialDate: data?.data[0]?.testimonialDate
              ? new Date(data?.data[0]?.testimonialDate)
              : '',
            keyLocation: data?.data[0]?.keyLocation || '',
            textAr: he.decode(data?.data[0]?.testimonial_AR || ''),
            messageAr: he.decode(data?.data[0]?.messageAR || ''),
            image: null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched, handleChange }) => (
            <Form>
              <div className={styles['steps']}>
                <div className={`${styles['step-container']} ${styles['rtl']}`}>
                  <TextInput
                    label="الاسم"
                    placeholder="أدخل الاسم"
                    icon={userIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    value={values.nameAr}
                    name="nameAr"
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                  <TextInput
                    label="المنصب"
                    placeholder="أدخل المنصب"
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.messageAr}
                    touched={touched.messageAr}
                    value={values.messageAr}
                    name="messageAr"
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                </div>
                <div className={styles['step-container']}>
                  <DateInput
                    label="تاريخ"
                    placeholder="حدد التاريخ"
                    showIcon
                    value={values.testimonialDate}
                    name="testimonialDate"
                    onChange={setFieldValue}
                    dateFormat="yyyy-MM-dd"
                    errors={errors.testimonialDate}
                    touched={touched.testimonialDate}
                  />
                  <CustomSelect
                    label="تعيين الصفحة"
                    placeholder="Select Page"
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    dropdownStyle={{ marginTop: '4px' }}
                    errors={errors.keyLocation}
                    touched={touched.keyLocation}
                    value={values.keyLocation}
                    onChange={(e) => {
                      setFieldValue('keyLocation', e.value);
                    }}
                    options={pageOptions
                      .filter((c) =>
                        type === 'speech'
                          ? c.speech === '1'
                          : c.testimonial === '1'
                      )
                      ?.map((option) => ({
                        value: option.value,
                        text: option.text,
                      }))}
                    right
                  />
                </div>
              </div>
              <div>
                <div className={`${styles['quill-container']} `}>
                  <TextEditor
                    label={type === 'speech' ? 'ادخل الخطاب ' : 'محتوى الشهادة'}
                    value={values.textAr}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    name="textAr"
                    placeholder={
                      type === 'speech' ? 'أدخل الخطاب' : 'أدخل الشهادة'
                    }
                    errors={errors.textAr}
                    touched={touched.textAr}
                    right
                  />
                </div>
              </div>
              <div style={{ marginTop: '30px' }}>
                <label>رفع الصورة</label>
              </div>
              {errors.image && (
                <div
                  className={styles['error-message']}
                  style={{ marginTop: '30px' }}
                >
                  <p>{errors.image}</p>
                </div>
              )}
              <UploadImage
                onCropImage={(croppedImageFile) =>
                  setFieldValue('image', croppedImageFile)
                }
                value={imageSrc}
                setFieldValue={(field, value) => console.log(field, value)}
              />
              <button
                type="submit"
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateSpeech;
